module.exports = __webpack_public_path__ + "darkimg-project.470bf1f4bdc66b2c77a4aa17aa1805db.hashedasset.svg";